<template lang='pug'>
include /mixins
+b.ds-panel--space_xl
  +e.element--offset_top.--indent_inside
    template(v-for='scope in items')
      +e.element--offset_vertical
        +b.ds-caption--size_md.--size_lg-xl.--medium.P {{ _('Добавьте') }} #[b {{ scope.amount_coefficient }} ] {{ _('товар из этой группы ') }}
          +b.ds-caption--size_md.--size_lg-xl.--medium.--color_accent.SPAN ({{ _('выбрано') }} {{ scope.amount }})
      +e.element--offset_vertical
        +b.g-row--space_xl-mac.--appearance_spaced
          +b.g-cell.g-cols--6.--6-md.--4-xl.--3-fhd(
            v-for='variant in scope.variants'
          )
            sales-variant-card(
              :variant='variant'
              :key='variant.id'
              @changeCount='changeCount(scope, variant, $event)'
              :max='getMax(scope) + variant.count'
            )
    +e.element--offset_vertical
      +b.sales-service-line.relative
        ui-loader(v-if='load')
        +b.g-row--space_xl-mac.--appearance_spaced.--align_center
          +b.g-cell.g-cols(v-if='isValid && !load')
            +b.ds-caption--size_md.--appearance_line-througt.P(
              v-html='getSplittedHtml(getTotalPriceWithoutDiscounts)'
              v-if='getTotalPriceWithoutDiscounts !== getTotalPrice'
            )
            +b.ds-caption--size_md.--bold.P(
              v-html='getSplittedHtml(getTotalPrice)'
            )

          +b.g-cell.g-cols
            +b.tt-button--size_md.--full_width.--color_accent.BUTTON(
              @click='addToCart'
              :disabled='!isValid'
            )
              +e.icon.icon-cart.SPAN
              +e.title.P {{ _('В корзину') }}
          +b.g-cell.g-cols(v-if='!isValid')
            +b.sale-error
              +e.icon
                svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none')
                  mask#mask0_5801_22921(style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24')
                    rect(width='24' height='24' fill='#D9D9D9')
                  g(mask='url(#mask0_5801_22921)')
                    path(
                      d='M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z'
                      fill='#F2061D'
                    )
              +e.text.P {{ _('Недостаточно товаров для формирования комплекта') }}
</template>

<script>
import { mapActions } from 'vuex'
import { getSalesGroups } from '@api/sales.service'
import {
  checkCartBySale,
  changeCartEntity,
  clearCartBySale,
} from '@api/cart.service'

import CartView from '@app/Cart/View'

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      cart: {},
      currency: window.currency,
      load: false,
    }
  },
  computed: {
    isValid() {
      return this.items.length && this.items.every(item => item.amount >= item.amount_coefficient)
    },
    getTotalPrice() {
      return this.cart.total_price
    },
    getTotalPriceWithoutDiscounts() {
      return this.cart.total_price_without_discounts
    },
  },
  watch: {
    items: {
      handler() {
        console.log('CHANGE');
        if (this.isValid) {
          this.getPrice()
        }
      },
      deep: true,
    },
  },
  created() {
    this.getSalesGroups()
  },
  methods: {
    ...mapActions('cart', [
      'getCart', 'getPackages', 'changeCart',
    ]),
    getMax(group) {
      const c = group.variants.reduce((acc, item) => acc + item.count || 0, 0)
      return group.amount_coefficient - c
    },
    async getSalesGroups() {
      const { data: { items } } = (await getSalesGroups.execute({ id: this.id }))
      this.items = items.map(item => ({
        ...item,
        amount: 0,
        variants: item.variants.map(v => ({ count: 0, ...v })),
      }))
    },
    changeCount(scope, variant, count) {
      variant.count = count
      console.log(scope);
      scope.amount = scope.variants.reduce((acc, item) => acc + item.count || 0, 0)
      this.$emit('changeCount', { ...variant, count })
    },
    prepareData() {
      const entities = this.items.reduce((acc, item) => {
        item.variants.forEach(variant => {
          if (!variant.count) return
          acc.push({
            element: {
              id: variant.id,
              type: variant.type,
            },
            quantity: variant.count,
          })
        })
        return acc
      }, [])
      return entities
    },
    async getPrice() {
      this.load = true
      const entities = this.prepareData()
      const { data } = (await checkCartBySale.execute({ campaign_id: this.id }, { entities }))
      this.load = false
      this.cart = data
    },
    async addToCart() {
      this.load = true
      const entities = this.prepareData()
      await this.changeCart({ data: { entities }, retrieve: false })
      // clearCartBySale.execute({ campaign_id: this.id })
      this.openCart()
      this.load = false
    },
    openCart() {
      this.$modal.show(
        CartView,
        {
          retrieve: false,
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },

}
</script>
